import * as _ from 'lodash';
import {fallbackLocalStorage} from './storage-cookie-fallback/index';
const WEB_STORAGE_KEY = 'compareModelLocalStorage_v1.1';
const WEB_STORAGE_CURRENT_SUPER_CAT_ID = 'currentSuperCategoryId';
const MAX_NUMBER_OF_MODELS_IN_STORAGE = 3;

/* Eventually, the following domain objects will need to be refactored into a domain folder */

export class CroModel {
    constructor(public id:number, public displayName: string, public brand: CroBrand, public supercategory: CroCategory) {}
}

export class CroBrand {
    constructor(public displayName: string) {}
}

export class CroCategory {
    constructor(public id: number, public pluralName, public targetPath?: string) {}
}

export class CompareModelStorageManager {

    private static m_instance = null;

    public static getInstance(): CompareModelStorageManager {
        if (_.isNil(CompareModelStorageManager.m_instance)) {
            CompareModelStorageManager.m_instance = new CompareModelStorageManager();
        }
        return CompareModelStorageManager.m_instance;
    }

    public setCurrentSuperCategoryId(id: number) {
        fallbackLocalStorage.setItem(WEB_STORAGE_CURRENT_SUPER_CAT_ID, _.toString(id));
    }

    public getCurrentSuperCategoryId(): number {
        return _.toNumber(fallbackLocalStorage.getItem(WEB_STORAGE_CURRENT_SUPER_CAT_ID));
    }

    public hasModel(model: CroModel): boolean {
        let models = this.getModels();
        if (_.isNil(models)) {
            return false;
        }
        for(let i in models) {
            const obj = models[i];
            if (obj.id == model.id) {
                return true;
            }
        }
        return false;
    }

    public hasModelById(id: Number): boolean {
        let models = this.getModels();

        if (_.isNil(models)) {
            return false;
        }

        for(let i in models) {
            const obj = models[i];

            if (obj.id == id) {
                return true;
            }
        }
        
        return false;
    }

    /**
     *
     * @param model
     */
    public removeModel(model: CroModel): void {
        if (this.hasModel(model)) {
            this.removeModelById(model.id);
        }
    }

    public removeModelById(id: number): void {
        let models = this.getModels();
        let newModels = _.filter(models, (obj: CroModel): boolean => {
            return id != obj.id;
        });
        this.updateStorage(newModels);
    }

    public getStorageRawValue(): string {
        let webstorage = fallbackLocalStorage.getItem(WEB_STORAGE_KEY);
        return webstorage;
    }

    public getModelById(id: number): CroModel {
        let models = this.getModels();
        let model = null;
        if (!_.isNil(models)) {
            for(let i = 0; i < models.length; i++) {
                let aModel = models[i];
                if (aModel.id == id) {
                    model = aModel;
                    break;
                }
            }
        }
        return model;
    }

    public getModelsByCategoryId(supercategoryId: number): CroModel[] {
        let models = _.filter(this.getModels(), (model: CroModel) => {
            return model.supercategory.id == supercategoryId;
        });
        return models;
    }
    
    public deserializeCroModel(json: string): CroModel {
        if (!_.isNil(json)) {
            let parsed = JSON.parse(json);
            return new CroModel(
                parsed.id, parsed.displayName,
                new CroBrand(parsed.brand.displayName),
                new CroCategory(parsed.supercategory.id, parsed.supercategory.pluralName)
            );
        }
        return null;
    }

    public countModels(supercategoryId: number): number {
        let models = this.getModelsByCategoryId(supercategoryId);
        if (_.isNil(models)) {
            return 0;
        } else {
            return models.length;
        }
    }

    public canAddMoreModels(supercategoryId: number): boolean {
        return this.countModels(supercategoryId) < MAX_NUMBER_OF_MODELS_IN_STORAGE;
    }

    public getModelIds(supercategoryId: number): number[] {
        if (this.countModels(supercategoryId) > 0) {
            return this.getModelIdsAsString(supercategoryId).split('-').map(Number);
        } else {
            return [];
        }
    }
    
    public getModelIdsAsString(supercategoryId: number): string {
        if (this.countModels(supercategoryId) == 0) {
            return "";
        } else {
            let models: CroModel[] = this.getModelsByCategoryId(supercategoryId);
            return _.map(models, (obj: CroModel, i) => {
                return obj.id;
            }).join("-");
        }
    }

    public addModel(model: CroModel): CroModel {
        if (!this.hasModel(model) && this.canAddMoreModels(model.supercategory.id)) {
            let models = this.getModels();
            models.push(model);
            this.updateStorage(models);
            return model;
        }
        return model;
    }

    public clearModels(): void {
        fallbackLocalStorage.removeItem(WEB_STORAGE_KEY);
    }

    protected updateStorage(models: CroModel[]): void {
        if (!_.isNil(models)) {
            let serialized = JSON.stringify(models);
            fallbackLocalStorage.setItem(WEB_STORAGE_KEY, serialized);
        }
    }

    // Work horse method that can cleverly cached / optimized
    protected getModels(): CroModel[] {
        let raw = this.getStorageRawValue();
        let modelsParse = JSON.parse(raw);
        let ret: CroModel[] = [];
        // We need to cast the results into CroModels
        if (!_.isNil(modelsParse)) {
            ret = _.map(modelsParse, (obj: any, i): CroModel => {
                return new CroModel(
                    obj.id, obj.displayName,
                    new CroBrand(obj.brand.displayName),
                    new CroCategory(obj.supercategory.id, obj.supercategory.pluralName)
                );
            })
        }
        return ret;
    }

}




// WEBPACK FOOTER //
// ./resources/modules/shared/helpers/CompareModelStorageManager.ts